import * as React from 'react';
import { SVGProps } from 'react';

const IconTopSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7.211 5.617 3.914 8.914 2.5 7.5l5.711-5.711 5.712 5.71-1.415 1.415-3.297-3.297v8.594h-2V5.617Z" />
  </svg>
);
export default IconTopSizeS;
